export default function authHeader() {
    let lang = localStorage.getItem("lang") || 'en';
    let accessToken = JSON.parse(localStorage.getItem('accessToken'));
    if (accessToken) {
        return { Authorization: 'Bearer ' + accessToken, 'platform': 'observe' };
    } else {
        return { 'X-localization': lang, 'platform': 'observe' };
    }
}
